import ChatDivide from "../../assets/img/subject_underline_shine_effect.png";
import React, {memo} from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    img: {
        width: '100%'
    }
})

const DivideSparkImg = ({className, ...props}) => {
    const classes = useStyles()
    return (<img src={ChatDivide} className={classes.img + ' ' + (className || '')} alt="---" {...props}/>)
}

export default memo(DivideSparkImg);